export const toNumberOrNull = (val: unknown) => {
  if (val === '' || val === null) {
    return null;
  }

  const num = Number(val);

  return isFinite(num) ? num : null;
};
